import script from "./AppBar2.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBar2.vue?vue&type=script&setup=true&lang=ts"

import "./AppBar2.vue?vue&type=style&index=0&id=3d736757&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d736757"]])

export default __exports__